// extracted by mini-css-extract-plugin
export default {"card":"SBly5","description":"spbsQ","card_content":"aq0BK","icon_active":"pZLbA","icon":"RjRc9"};